// @ vendors
const { Promise } = require('es6-promise');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @ actions
const { requestInsuranceCurrentPricing } = require('./insuranceRequestWizardStep4');

// @ constants
const {
    INSURANCE_REQUEST_FREE_STARTED,
    INSURANCE_REQUEST_COMBINED_STARTED,
    INSURANCE_REQUEST_STATE_REQUEST,
    INSURANCE_REQUEST_STATE_SUCCESS,
    INSURANCE_REQUEST_STATE_FAILURE,
    INSURANCE_REQUEST_RECOMMENDATION_REQUEST,
    INSURANCE_REQUEST_RECOMMENDATION_SUCCESS,
    INSURANCE_REQUEST_RECOMMENDATION_FAILURE
} = require('../../insuranceConstants/actionTypes');
const {
    STANDALONE_RELATED_INSURANCE,
} = require('constants/flagBasedFeatures');

const requestInsuranceStateInProgress = reset => ({
    type: INSURANCE_REQUEST_STATE_REQUEST,
    data: { reset }
});

const requestInsuranceStateSuccess = data => ({
    type: INSURANCE_REQUEST_STATE_SUCCESS,
    data
});

const requestInsuranceStateFailure = error => ({
    type: INSURANCE_REQUEST_STATE_FAILURE,
    data: { error }
});

const requestInsuranceRecommendationInProgress = () => ({
    type: INSURANCE_REQUEST_RECOMMENDATION_REQUEST
});

const insuranceRequestFreeStarted = (isCombinedMortgaged = null) => (dispatch, getState) => {
    const isEnabledFF = getState().flagBasedFeatures.get(STANDALONE_RELATED_INSURANCE);
    dispatch({
        type: INSURANCE_REQUEST_FREE_STARTED,
        payload: {
            isEnabledFF,
            isCombinedMortgaged
        }
    });
}

const insuranceRequesCombinedStarted = () => (dispatch) => {
    dispatch({
        type: INSURANCE_REQUEST_COMBINED_STARTED
    });
}

const requestInsuranceRecommendationSuccess = data => ({
    type: INSURANCE_REQUEST_RECOMMENDATION_SUCCESS,
    data
});

const requestInsuranceRecommendationFailure = error => ({
    type: INSURANCE_REQUEST_RECOMMENDATION_FAILURE,
    data: { error }
});

const requestInsuranceCurrentState = (reset = false) => (dispatch, getState) => {
    const currentState = getState().insuranceRequestState;

    if (!currentState.get('isFetching')) {
        dispatch(requestInsuranceStateInProgress(reset));

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestCurrentStateRequest')
        )
            .then(response => {
                dispatch(requestInsuranceStateSuccess(response.data));
                if (response.data && response.data.id) {
                    requestInsuranceCurrentPricing(response.data.id)(dispatch, getState);
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestInsuranceStateFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const requestInsuranceRecommendation = (data, forceRequest= false) => (dispatch, getState) => {
    const currentState = getState().insuranceRequestState;

    if (forceRequest || !currentState.get('isFetchingRecommendation')) {
        dispatch(requestInsuranceRecommendationInProgress());

        const params = {
            query: {
                size: data.size,
                propertyType: data.propertyType,
                propertyCharacter: data.propertyCharacter,
                propertyUsage: data.propertyUsage,
                content: data.content,
                provinceId: data.provinceId
            }
        };

        return APIGet({
            dispatch,
            endpoint: 'insuranceRecommentation',
            params
        })
            .then(response => {
                dispatch(requestInsuranceRecommendationSuccess(response.recommendation));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestInsuranceRecommendationFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

module.exports = {
    requestInsuranceCurrentState,
    requestInsuranceRecommendation,
    insuranceRequesCombinedStarted,
    insuranceRequestFreeStarted,
};
